module.exports = __webpack_public_path__ + "media/images/application/template/boxplus/preesall-park-storage-logo-18e55219173d10f2b4513b5309faa7e4.png";